import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {Krk} from '../../../shared/interface/krk';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {takeUntil} from 'rxjs/operators';
import {AuthService} from '../../../shared/services/auth.service';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {KrkService} from '../../../shared/services/krk.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {Ofwca} from '../../../shared/interface/ofwca';

@Component({
  selector: 'app-krk-details-view',
  templateUrl: './krk-details-view.component.html',
  styleUrls: ['./krk-details-view.component.scss']
})
export class KrkDetailsViewComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() krk: Observable<Krk>;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;
  krkObject?: Krk;

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private krkService: KrkService,
    private snack: MatSnackBar,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.krk
      .pipe(takeUntil(this.destroyed$))
      .subscribe((krk: Krk) => this.krkObject = krk);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć KRK?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.krkService.deleteKrk(this.krkObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto KRK', '', {duration: 2000});
            this.router.navigate(['/krk']);
          });
      }
    });
  }
}
